// AUTO-GENERATED from the live ester1.fi content (DatoCMS export).
// Safe to hand-edit: this is now the source of truth for site content.

const { asset } = require('./assets');

const tilat = [
  {
    id: "DatoCmsTilat-2050956-fi",
    nimi: "152 neliötä",
    tilanNeliot: 152,
    hintaNelio: 23,
    hintaNelio2: 22.5,
    hintaNelio3: 22,
    hintaNelio4: 21.5,
    hintaNelio5: 21,
    kuva: asset("1615885930-tila-152m.jpg", {
      sizes: "(max-width: 1100px) 100vw, 1100px",
      aspectRatio: 2.157165,
    }),
  },
  {
    id: "DatoCmsTilat-2050959-fi",
    nimi: "152 neliötä",
    tilanNeliot: 152,
    hintaNelio: 23,
    hintaNelio2: 22.5,
    hintaNelio3: 22,
    hintaNelio4: 21.5,
    hintaNelio5: 21,
    kuva: asset("1615885930-tila-152m.jpg", {
      sizes: "(max-width: 1100px) 100vw, 1100px",
      aspectRatio: 2.157165,
    }),
  },
  {
    id: "DatoCmsTilat-2051821-fi",
    nimi: "153,5 neliötä",
    tilanNeliot: 153.5,
    hintaNelio: 23,
    hintaNelio2: 22.5,
    hintaNelio3: 22,
    hintaNelio4: 21.5,
    hintaNelio5: 21,
    kuva: asset("1615885963-tila-153-5m.jpg", {
      sizes: "(max-width: 1100px) 100vw, 1100px",
      aspectRatio: 2.157165,
    }),
  },
  {
    id: "DatoCmsTilat-2051822-fi",
    nimi: "237 neliötä",
    tilanNeliot: 237,
    hintaNelio: 23,
    hintaNelio2: 22.5,
    hintaNelio3: 22,
    hintaNelio4: 21.5,
    hintaNelio5: 21,
    kuva: asset("1628251462-tila-237m-uusi.jpg", {
      sizes: "(max-width: 1100px) 100vw, 1100px",
      aspectRatio: 2.157165,
    }),
  },
  {
    id: "DatoCmsTilat-2051823-fi",
    nimi: "238,5 neliötä",
    tilanNeliot: 238.5,
    hintaNelio: 23,
    hintaNelio2: 22.5,
    hintaNelio3: 22,
    hintaNelio4: 21.5,
    hintaNelio5: 21,
    kuva: asset("1615886006-tila-238-5m.jpg", {
      sizes: "(max-width: 1100px) 100vw, 1100px",
      aspectRatio: 2.157165,
    }),
  },
  {
    id: "DatoCmsTilat-2051824-fi",
    nimi: "252,5 neliötä",
    tilanNeliot: 252.5,
    hintaNelio: 23,
    hintaNelio2: 22.5,
    hintaNelio3: 22,
    hintaNelio4: 21.5,
    hintaNelio5: 21,
    kuva: asset("1615886023-tila-252-5m.jpg", {
      sizes: "(max-width: 1100px) 100vw, 1100px",
      aspectRatio: 2.157165,
    }),
  },
  {
    id: "DatoCmsTilat-2051825-fi",
    nimi: "321,5 neliötä",
    tilanNeliot: 321.5,
    hintaNelio: 23,
    hintaNelio2: 22.5,
    hintaNelio3: 22,
    hintaNelio4: 21.5,
    hintaNelio5: 21,
    kuva: asset("1615886040-tila-321-5m.jpg", {
      sizes: "(max-width: 1100px) 100vw, 1100px",
      aspectRatio: 2.157165,
    }),
  },
  {
    id: "DatoCmsTilat-2051827-fi",
    nimi: "377,5 neliötä",
    tilanNeliot: 377.5,
    hintaNelio: 23,
    hintaNelio2: 22.5,
    hintaNelio3: 22,
    hintaNelio4: 21.5,
    hintaNelio5: 21,
    kuva: asset("1615886050-tila-377-5m.jpg", {
      sizes: "(max-width: 1100px) 100vw, 1100px",
      aspectRatio: 2.157165,
    }),
  },
  {
    id: "DatoCmsTilat-24631623-fi",
    nimi: "404 neliötä",
    tilanNeliot: 404,
    hintaNelio: 23,
    hintaNelio2: 22.5,
    hintaNelio3: 22,
    hintaNelio4: 21.5,
    hintaNelio5: 21,
    kuva: asset("1615886079-tila-404m.jpg", {
      sizes: "(max-width: 1100px) 100vw, 1100px",
      aspectRatio: 2.157165,
    }),
  },
  {
    id: "DatoCmsTilat-24631627-fi",
    nimi: "475 neliötä",
    tilanNeliot: 475,
    hintaNelio: 23,
    hintaNelio2: 22.5,
    hintaNelio3: 22,
    hintaNelio4: 21.5,
    hintaNelio5: 21,
    kuva: asset("1615886108-tila-475m.jpg", {
      sizes: "(max-width: 1100px) 100vw, 1100px",
      aspectRatio: 2.157165,
    }),
  },
  {
    id: "DatoCmsTilat-24631628-fi",
    nimi: "523 neliötä",
    tilanNeliot: 523,
    hintaNelio: 23,
    hintaNelio2: 22.5,
    hintaNelio3: 22,
    hintaNelio4: 21.5,
    hintaNelio5: 21,
    kuva: asset("1615886138-tila-523m.jpg", {
      sizes: "(max-width: 1100px) 100vw, 1100px",
      aspectRatio: 2.157165,
    }),
  },
  {
    id: "DatoCmsTilat-24631630-fi",
    nimi: "658 neliötä",
    tilanNeliot: 658,
    hintaNelio: 23,
    hintaNelio2: 22.5,
    hintaNelio3: 22,
    hintaNelio4: 21.5,
    hintaNelio5: 21,
    kuva: asset("1615886162-tila-658m.jpg", {
      sizes: "(max-width: 1100px) 100vw, 1100px",
      aspectRatio: 2.157165,
    }),
  },
  {
    id: "DatoCmsTilat-24631633-fi",
    nimi: "715,5 neliötä",
    tilanNeliot: 715.5,
    hintaNelio: 23,
    hintaNelio2: 22.5,
    hintaNelio3: 22,
    hintaNelio4: 21.5,
    hintaNelio5: 21,
    kuva: asset("1615886190-tila-715-5m.jpg", {
      sizes: "(max-width: 1100px) 100vw, 1100px",
      aspectRatio: 2.157165,
    }),
  },
  {
    id: "DatoCmsTilat-24631634-fi",
    nimi: "719 neliötä",
    tilanNeliot: 719,
    hintaNelio: 23,
    hintaNelio2: 22.5,
    hintaNelio3: 22,
    hintaNelio4: 21.5,
    hintaNelio5: 21,
    kuva: asset("1615886219-tila-719m.jpg", {
      sizes: "(max-width: 1100px) 100vw, 1100px",
      aspectRatio: 2.157165,
    }),
  },
];

module.exports = { tilat };
